import styled from 'styled-components';

export const FooterContainer = styled('footer')`
  margin-top: auto;
  padding-top: 30px;
  padding-bottom: 20px;
`;

export const Content = styled('div')`
  text-align: center;
`;

export const LogoContainer = styled('div')`
  width: 155px;
  margin: auto;
`;
